(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crack-initiation-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ci-section]').forEach((section) => {
    const mainImage = section.querySelector('.ci-gallery__main');
    const price = section.querySelector('[data-ci-price]');

    section.querySelectorAll('[data-ci-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = thumb.dataset.src;
        mainImage.srcset = '';
        mainImage.alt = thumb.dataset.alt || '';
        section.querySelectorAll('[data-ci-thumb]').forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    section.querySelectorAll('input[name="id"]').forEach((variantInput) => {
      variantInput.addEventListener('change', () => {
        if (price && variantInput.dataset.price) price.textContent = variantInput.dataset.price;
        if (mainImage && variantInput.dataset.image) {
          mainImage.src = variantInput.dataset.image;
          mainImage.srcset = '';
          mainImage.alt = variantInput.dataset.imageAlt || '';
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantInput.value);
        window.history.replaceState({}, '', url);
      });
    });

    section.querySelectorAll('a[href^="#crack-initiation-form-"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const form = section.querySelector('.ci-buybox__form');
        if (!form) return;
        event.preventDefault();
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-newsletter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-dl-klaviyo]')) return;
    event.preventDefault();
    if (form.dataset.submitting === 'true' || !form.reportValidity()) return;
    const button = form.querySelector('button[type="submit"]');
    const message = form.querySelector('.dl-news__msg');
    form.dataset.submitting = 'true';
    button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    message.hidden = true;
    try {
      const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(form.dataset.companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Homepage newsletter - POPUP-25',
              profile: { data: { type: 'profile', attributes: { email: form.elements.email.value.trim() } } }
            },
            relationships: { list: { data: { type: 'list', id: form.dataset.listId } } }
          }
        }),
        signal: AbortSignal.timeout(15000)
      });
      if (!response.ok) throw new Error('Subscription failed');
      message.textContent = form.dataset.success;
      form.querySelector('.dl-news__row').hidden = true;
      form.querySelector('label').hidden = true;
    } catch (error) {
      message.textContent = form.dataset.error;
      button.disabled = false;
    } finally {
      message.hidden = false;
      form.removeAttribute('aria-busy');
      delete form.dataset.submitting;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-og-video-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  const button = event.target.closest('.dl-og-videos__poster');
  if (!button) return;
  const id = button.dataset.videoId;
  if (!/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
  const start = Math.max(0, parseInt(button.dataset.start || '0', 10) || 0);
  const iframe = document.createElement('iframe');
  iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0' + (start ? '&start=' + start : '');
  iframe.title = button.getAttribute('aria-label');
  iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
  iframe.allowFullscreen = true;
  iframe.referrerPolicy = 'strict-origin-when-cross-origin';
  button.replaceWith(iframe);
});

  } catch(e) { console.error(e); }
})();
})();
